import { render, staticRenderFns } from "./idCar.vue?vue&type=template&id=6d51196e&scoped=true&"
import script from "./idCar.vue?vue&type=script&lang=js&"
export * from "./idCar.vue?vue&type=script&lang=js&"
import style0 from "./idCar.vue?vue&type=style&index=0&id=6d51196e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d51196e",
  null
  
)

export default component.exports